module.exports = __webpack_public_path__ + "static/media/danTrav.5abd6752.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/danTrav.png
// module id = 197
// module chunks = 0